export default "__VITE_ASSET__CpEcVxRF__"